// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Compress = React.forwardRef(function Compress(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M8 19h3v3h2v-3h3l-4-4-4 4zm8-15h-3V1h-2v3H8l4 4 4-4zM4 9v2h16V9H4zm0 3h16v2H4z"/></SvgIcon>;
});
export default Compress;
